export const ADD_USER = "ADD_USER";
export const GET_USERS = "GET_USERS";
export const ERROR = "ERROR";
export const LOGIN_USER = "LOGIN_USER";
export const LOGIN_USER_ERROR = "LOGIN_USER_ERROR";
